module.exports = __webpack_public_path__ + "static/paper-9ba6f28ca0badf6b005504d3b2909e08.png";